/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const audioPartFilterEnum = z.enum(['title', 'definition', 'usageNotes', 'examples']);

export type AudioPartFilter = z.infer<typeof audioPartFilterEnum>;

export const getChallengesNeedingAudioV1BodySchema = z.object({
  limit: z.number().int().positive().max(5000),
  force: z.boolean().optional().default(false),
  fullAudio: z.boolean().optional().default(false),
  part: audioPartFilterEnum.optional(),
});

export type IGetChallengesNeedingAudioV1Body = z.input<
  typeof getChallengesNeedingAudioV1BodySchema
>;
